








import Vue from 'vue';
import TNC from '@/components/tnc.vue';
import { getTNCConfig } from '@/business';
import { util, CustomException } from '@tencent/ppd-base-libs';
import { showDialog } from '@tencent/wphk-components-dialog';
import { i18n } from '@/i18n';
import { BaseComponent } from '@tencent/wphk-components-content-loader';
import ContentLoader from '@/components/content-loader.vue';

export default Vue.extend({
  name: 'home',
  components: {
    TNC,
    BaseComponent,
    ContentLoader,
  },
  data() {
    return {
      config: undefined,
      isReady: false,
    };
  },
  async created() {
    const { type, tncId } = this.$route.query;
    const [err, data] = await util.to(getTNCConfig(type as string, tncId as string));
    if (err || !data) {
      showDialog({
        content: i18n('條款及細則訪問繁忙'),
        btns: [],
      });
      throw new CustomException(err, 'TncNotFound', `type: ${type}, tncId: ${tncId}`);
    }
    this.isReady = true;
    document.title = data.title;
    this.config = data;
  },
});
